import {Component, Input, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
import {NavItem} from './nav-item';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'tr2-app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent implements OnInit {
  @Input() items: NavItem[];
  @ViewChild('childMenu', { static: true }) public childMenu;

  constructor() {
  }

  @Output() establecido = new EventEmitter();

  ngOnInit() {
  }

  click(item) {
		this.establecido.emit(item);
	}
}
